module.exports = __webpack_public_path__ + "media/images/emblems/Dizy-coat_of_arms-1b7c4d666430ea036a0438ec69c5584d.svg";